import React, { useState } from "react";
import noImage from "../../assets/nologo.gif";
import {
  FaPhone,
  FaEnvelope,
  FaGlobe,
  FaMapMarkerAlt,
  FaBuilding,
} from "react-icons/fa";
import SupplierDetailsModal from "./SupplierDetailsModal";

function SupplierContactCard({ supplier }) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div
        className="bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300 p-4 w-full cursor-pointer"
        onClick={() => setShowModal(true)}
      >
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0">
            <img
              src={supplier.logo || noImage}
              className="w-16 h-16 object-contain rounded-lg border border-gray-100"
              alt={`${supplier.name} logo`}
            />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-lg font-semibold text-[#363062] truncate">
              {supplier.name}
            </h3>

            <div className="mt-2 space-y-1.5">
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <FaPhone className="text-[#363062] w-3.5 h-3.5" />
                <span>{supplier.phone}</span>
              </div>

              {supplier.email && (
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <FaEnvelope className="text-[#363062] w-3.5 h-3.5" />
                  <span className="truncate">{supplier.email}</span>
                </div>
              )}

              {supplier.address && supplier.address !== "not indicated" && (
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <FaMapMarkerAlt className="text-[#363062] w-3.5 h-3.5" />
                  <span className="truncate">{supplier.address}</span>
                </div>
              )}

              <div className="flex items-center gap-2 text-sm text-gray-600">
                <FaBuilding className="text-[#363062] w-3.5 h-3.5" />
                <span className="text-[#8FCD00] font-medium">
                  {supplier.services[0]}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <SupplierDetailsModal
          supplier={supplier}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
}

export default SupplierContactCard;
